import axios from 'src/utils/instantAxios.js';

export const instructionServices = {
   getInstruction: (payload) => axios.get('api/get-instruction', { params: { ...payload } }),
};
